import React from "react";

export default function ModalBody({ children }) {
  return (
    <div
      style={{
        padding: "18px 24px",
        overflowY: "auto",
      }}
    >
      {children}
    </div>
  );
}
